import { BillingStatus } from '@inversor-hub/types';

export const statusLabelMap: Record<BillingStatus, string> = {
  NONE: 'Sin suscripción',
  INCOMPLETE: 'Pendiente',
  TRIALING: 'En prueba',
  ACTIVE: 'Activa',
  PAST_DUE: 'Pago pendiente',
  CANCELED: 'Cancelada',
  UNPAID: 'Impagada',
};

export const planLabelMap = {
  STARTER: 'Prueba',
  INVERSOR: 'Inversor',
  PORTFOLIO: 'Patrimonio',
} as const;

export const formatBillingDate = (date?: string) =>
  date
    ? new Intl.DateTimeFormat('es-ES', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      }).format(new Date(date))
    : undefined;
